<template>
  <tr class="mds-data-table__row group-end">
    <td class="mds-data-table__cell"></td>
    <td class="mds-data-table__cell" scope="row" colspan="2">
      <button class="mds-button mds-button--flat change-status__toggle-clients" type="button" @click="toggleClient">
        <svg class="mds-icon mds-button__icon mds-button__icon--left" aria-hidden="true">
          <use xlink:href="static/mds/icons/mds.svg#triangle-fill-right" v-if="!display">
            <title>triangle-fill-right</title>
          </use>
          <use xlink:href="static/mds/icons/mds.svg#triangle-fill-down" v-else>
            <title>triangle-fill-down</title>
          </use>
        </svg>
        <span class="mds-button__text"> Clients </span>
      </button>
    </td>
    <td class="mds-data-table__cell"></td>
    <td class="mds-data-table__cell"></td>
    <td class="mds-data-table__cell"></td>
  </tr>
</template>
<script>
export default {
  name: 'change-status-clients-header',
  props: {
    display: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    toggleClient() {
      this.$emit('toggleClient', !this.display);
    },
  },
};
</script>
